
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M14.684 7.263l-6.5 3.546m6.5 5.928l-6.5-3.546M19 6a2 2 0 11-3.999.001A2 2 0 0119 6zM8 12a2 2 0 11-3.999.001A2 2 0 018 12zm11 6a2 2 0 11-3.999.001A2 2 0 0119 18z"}})])
          )
        }
      }
    